'use strict';

var React = require('react');

var SvgLogOutMinor = function SvgLogOutMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-.707-10.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414l1.293-1.293h-3.586a1 1 0 1 1 0-2h3.586l-1.293-1.293z"
  }));
};

exports.SvgLogOutMinor = SvgLogOutMinor;
